"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _globalComponentsLibrary = require("global-components-library");
var _react = _interopRequireWildcard(require("react"));
var _reactstrap = require("reactstrap");
var _classnames = _interopRequireDefault(require("../../utils/classnames"));
var _constants = require("../../utils/constants");
require("./AudiosMessage.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var speeds = [1.0, 1.5, 2.0];
var AudiosMessage = function AudiosMessage(_ref) {
  var url = _ref.url,
    source = _ref.source,
    disabled = _ref.disabled,
    _ref$speedSelected = _ref.speedSelected,
    speedSelected = _ref$speedSelected === void 0 ? 0 : _ref$speedSelected,
    changeSpeed = _ref.changeSpeed,
    image = _ref.image,
    setCurrentAudio = _ref.setCurrentAudio,
    currentAudio = _ref.currentAudio;
  var classes = (0, _classnames["default"])({
    disabled: disabled,
    response: source !== _constants.MSG_SOURCE.USER,
    admin: source === _constants.MSG_SOURCE.ADMIN,
    coaching: source === _constants.MSG_SOURCE.COACH
  });
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isListened = _useState2[0],
    setIsListened = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    play = _useState4[0],
    setPlay = _useState4[1];
  var _useState5 = (0, _react.useState)(0),
    _useState6 = _slicedToArray(_useState5, 2),
    duration = _useState6[0],
    setDuration = _useState6[1];
  var _useState7 = (0, _react.useState)(0),
    _useState8 = _slicedToArray(_useState7, 2),
    currentTime = _useState8[0],
    setCurrentTime = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState9, 2),
    loadingAudio = _useState10[0],
    setLoadingAudio = _useState10[1];
  var audioPlayer = (0, _react.useRef)();
  var progressBar = (0, _react.useRef)();
  var animationRef = (0, _react.useRef)();
  var aRef = (0, _react.useRef)(null);
  var download = function download() {
    aRef.current.click();
  };
  (0, _react.useEffect)(function () {
    if (play !== undefined && play) {
      setIsListened(true);
      setData();
      audioPlayer.current.play();
      animationRef.current = requestAnimationFrame(whilePlaying);
    } else {
      audioPlayer.current.pause();
      cancelAnimationFrame(animationRef.current);
    }
  }, [play, duration]);
  var whilePlaying = function whilePlaying() {
    if (duration > 0 && duration !== Infinity && duration !== NaN) {
      progressBar.current.value = audioPlayer.current.currentTime;
      changePlayerCurrentTime();
      animationRef.current = requestAnimationFrame(whilePlaying);
    }
  };
  var changeRange = function changeRange() {
    audioPlayer.current.currentTime = progressBar.current.value;
    changePlayerCurrentTime();
  };
  var changePlayerCurrentTime = function changePlayerCurrentTime() {
    progressBar.current.style.setProperty('--seek-before-width', "".concat(Math.floor(progressBar.current.value / duration * 100), "%"));
    setCurrentTime(progressBar.current.value);
    if (audioPlayer.current.currentTime === audioPlayer.current.duration) {
      setPlay(false);
      setDuration(0);
      setCurrentTime(0);
      progressBar.current.style.setProperty('--seek-before-width', "0%");
      audioPlayer.current.currentTime = 0;
      setCurrentAudio(null);
    }
  };
  var calculateTime = function calculateTime(secs) {
    var minutes = Math.floor(secs / 60);
    var returnedMinutes = minutes < 10 ? "0".concat(minutes) : "".concat(minutes);
    var seconds = Math.floor(secs % 60);
    var returnedSeconds = seconds < 10 ? "0".concat(seconds) : "".concat(seconds);
    return "".concat(returnedMinutes, ":").concat(returnedSeconds);
  };
  var setData = function setData() {
    var seconds = Math.floor(audioPlayer.current.duration);
    setDuration(seconds);
    progressBar.current.max = seconds;
    if (seconds === Infinity) {
      setLoadingAudio(true);
      audioPlayer.current.volume = 0.0;
    }
    audioPlayer.current.ondurationchange = function () {
      if (this.duration !== Infinity) {
        setLoadingAudio(false);
        setDuration(Math.floor(this.duration));
        progressBar.current.max = Math.floor(this.duration);
        progressBar.current.style.setProperty('--seek-before-width', "0%");
        setCurrentTime(0);
        audioPlayer.current.pause();
        audioPlayer.current.currentTime = 0;
        setTimeout(function () {
          audioPlayer.current.volume = 1.0;
          audioPlayer.current.play();
        }, 200);
      }
    };
  };
  (0, _react.useEffect)(function () {
    if (audioPlayer && audioPlayer.current) {
      audioPlayer.current.playbackRate = speeds[speedSelected];
    }
  }, [speedSelected]);
  var resetAudio = function resetAudio() {
    if (progressBar && audioPlayer) {
      progressBar.current.value = 0;
      progressBar.current.style.setProperty('--seek-before-width', "0%");
      setDuration(0);
      setCurrentTime(0);
      audioPlayer.current.pause();
      audioPlayer.current.currentTime = 0;
      setCurrentAudio(null);
    }
  };
  (0, _react.useEffect)(function () {
    if (currentAudio != null) {
      if (currentAudio.url === url) {
        setPlay(currentAudio.play);
      } else {
        setPlay(false);
        setLoadingAudio(false);
        resetAudio();
      }
    }
  }, [currentAudio]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'uin-audio-message ' + classes
  }, /*#__PURE__*/_react["default"].createElement("a", {
    ref: aRef,
    href: url,
    target: "_blank",
    rel: "noreferrer",
    type: "audio/mpeg",
    style: {
      display: 'none'
    }
  }, "audio"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-audio-message-rep ".concat(classes)
  }, /*#__PURE__*/_react["default"].createElement("audio", {
    /* onLoadedMetadata={setData} */ref: audioPlayer,
    src: url,
    preload: "metadata"
  }), loadingAudio ? /*#__PURE__*/_react["default"].createElement(_reactstrap.Spinner, {
    className: "loadIconAudio ".concat(classes)
  }) : /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.ButtonIcon, {
    icon: play ? 'pause' : 'play',
    size: "large",
    onClick: function onClick() {
      return setCurrentAudio({
        url: url,
        play: !play
      });
    },
    disabled: disabled
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-audio-message-progress"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    className: "progressBar ".concat(isListened ? 'listened' : ''),
    type: "range",
    defaultValue: "0",
    ref: progressBar,
    onChange: changeRange
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-audio-time"
  }, calculateTime(currentTime)))), !play ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-audio-message-icon"
  }, source === _constants.MSG_SOURCE.USER && image ? image : /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-audio-message-agent"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon large headset"
  }))) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-audio-message-speed",
    onClick: changeSpeed
  }, /*#__PURE__*/_react["default"].createElement("div", null, speeds[speedSelected])), /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.ButtonIcon, {
    icon: "download",
    onClick: function onClick() {
      return download();
    }
  }));
};
var _default = exports["default"] = AudiosMessage;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/MultimediaMessages/AudiosMessage.js
// module id = 1419
// module chunks = 0